import {
  BarChartOutlined,
  BarcodeOutlined,
  CheckCircleOutlined,
  DatabaseOutlined,
  ExceptionOutlined,
  FileSearchOutlined,
  FileSyncOutlined,
  FormOutlined,
  FundProjectionScreenOutlined,
  LogoutOutlined,
  ScissorOutlined,
  SnippetsOutlined,
  UserOutlined,
  WechatFilled,
} from "@ant-design/icons";
import { MenuProps } from "antd";
import { ImageIcon } from "../components/styled-components";
import { getItem } from "../functions/function";
import { PATHNAME } from "../res/pathName";

const MENU_ADMIN: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Reserve Stock", PATHNAME.RESERVE_STOCK, <DatabaseOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Gen Batch", PATHNAME.PRINT_BATCH),
    getItem("Calendar Order ", PATHNAME.MANAGE_ORDER),
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
    // getItem("Batch Schedule", PATHNAME.BATCH_SCHEDULE),
  ]),

  getItem("So Management", PATHNAME.ORDER_SO, <ExceptionOutlined />),
  getItem("Edit SKU(Holder)", "sub7", <FileSyncOutlined />, [
    getItem("Add SKU", PATHNAME.EDITSKUADD),
    getItem("Edit Order", PATHNAME.EDITONEORDERTABLE),
    getItem("Edit Multi Order", PATHNAME.EDITONEORDERMULTI),
  ]),

  getItem("Manage Status Order", "sub9", <FormOutlined />, [
    getItem("Waiting Order", PATHNAME.EDITWAITING),
    getItem("Holder Order ", PATHNAME.EDITHOLDER),
  ]),

  getItem("Re-check Order", PATHNAME.RECHECK_ORDER, <CheckCircleOutlined />),
  getItem(
    "Focus",
    "sub3",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [getItem("Pick", PATHNAME.PICK_FOCUS), getItem("Pack", PATHNAME.PACK_FOCUS)],
  ),

  getItem("Cutting Page", PATHNAME.CUTTING_PAGE, <ScissorOutlined />),
  getItem("Code G", PATHNAME.CODE_G_PAGE, <BarcodeOutlined />),
  getItem(
    "Check Out",
    "sub4",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [
      getItem("Update tracking ", PATHNAME.UPLOADTRACKING),
      getItem("CheckOut Focus", PATHNAME.CHECKOUTORDER_FOCUS),
      getItem("Cancel Checkout", PATHNAME.RETURNORDERFOCUS),
      getItem("Shipping Management", PATHNAME.SHIPPING_MANAGE),
    ],
  ),

  getItem("Supervisor Dashboard", PATHNAME.SUPERVISORDASHBOARD, <BarChartOutlined />),

  getItem("User Management", "sub5", <UserOutlined />, [
    getItem("พนักงานในระบบ", PATHNAME.USER_ALL),
    getItem("เพิ่ม/แก้ไข พนักงาน", PATHNAME.USER_MANAGED),
  ]),

  getItem("Order History", PATHNAME.ORDER_HISTORY, <SnippetsOutlined />),
  getItem("Report Order", PATHNAME.REPORT_ORDER, <FundProjectionScreenOutlined />),
  getItem("Hydro Chat", PATHNAME.HYDRO_CHAT, <WechatFilled />),
];

const MENU_SUBADMIN: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Calendar Order ", PATHNAME.MANAGE_ORDER),
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
  ]),

  getItem("User Management", "sub5", <UserOutlined />, [
    getItem("พนักงานในระบบ", PATHNAME.USER_ALL),
    getItem("เพิ่ม/แก้ไข พนักงาน", PATHNAME.USER_MANAGED),
  ]),

  getItem("Edit SKU(Holder)", "sub7", <FileSyncOutlined />, [
    getItem("Add SKU", PATHNAME.EDITSKUADD),
    getItem("Edit Order", PATHNAME.EDITONEORDERTABLE),
    getItem("Edit Multi Order", PATHNAME.EDITONEORDERMULTI),
  ]),

  getItem("Cutting Page", PATHNAME.CUTTING_PAGE, <ScissorOutlined />),
  getItem("Code G", PATHNAME.CODE_G_PAGE, <BarcodeOutlined />),
  getItem("Hydro Chat", PATHNAME.HYDRO_CHAT, <WechatFilled />),
];

const MENU_WORKER: MenuProps["items"] = [
  getItem(
    "Focus",
    "sub3",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [getItem("Pick", PATHNAME.PICK_FOCUS), getItem("Pack", PATHNAME.PACK_FOCUS)],
  ),

  getItem("Cutting Page", PATHNAME.CUTTING_PAGE, <ScissorOutlined />),
  getItem(
    "Check Out",
    "sub4",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [
      getItem("Update tracking ", PATHNAME.UPLOADTRACKING),
      getItem("CheckOut Focus", PATHNAME.CHECKOUTORDER_FOCUS),
      getItem("Cancel Checkout", PATHNAME.RETURNORDERFOCUS),
      getItem("Shipping Management", PATHNAME.SHIPPING_MANAGE),
    ],
  ),
];

const MENU_ZONE: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Reserve Stock", PATHNAME.RESERVE_STOCK, <DatabaseOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Gen Batch", PATHNAME.PRINT_BATCH),
    getItem("Calendar Order ", PATHNAME.MANAGE_ORDER),
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
  ]),

  getItem(
    "Focus",
    "sub3",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [getItem("Pick", PATHNAME.PICK_FOCUS), getItem("Pack", PATHNAME.PACK_FOCUS)],
  ),

  getItem("Cutting Page", PATHNAME.CUTTING_PAGE, <ScissorOutlined />),
  getItem(
    "Check Out",
    "sub4",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [
      getItem("Update tracking ", PATHNAME.UPLOADTRACKING),
      getItem("CheckOut Focus", PATHNAME.CHECKOUTORDER_FOCUS),
      getItem("Cancel Checkout", PATHNAME.RETURNORDERFOCUS),
      getItem("Shipping Management", PATHNAME.SHIPPING_MANAGE),
    ],
  ),

  getItem("Report Order", PATHNAME.REPORT_ORDER, <FundProjectionScreenOutlined />),
  getItem("Hydro Chat", PATHNAME.HYDRO_CHAT, <WechatFilled />),
];

const MENU_VIEWER: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Reserve Stock", PATHNAME.RESERVE_STOCK, <DatabaseOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
  ]),
];

const MENU_ADMIN_RBN: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Reserve Stock", PATHNAME.RESERVE_STOCK, <DatabaseOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Gen Batch", PATHNAME.PRINT_BATCH),
    getItem("Calendar Order ", PATHNAME.MANAGE_ORDER),
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
  ]),

  getItem("So Management", PATHNAME.ORDER_SO, <ExceptionOutlined />),
  getItem("Order History", PATHNAME.ORDER_HISTORY, <SnippetsOutlined />),
  getItem("Re-check Order", PATHNAME.RECHECK_ORDER, <CheckCircleOutlined />),
  getItem(
    "Focus",
    "sub3",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [getItem("Pick", PATHNAME.PICK_FOCUS), getItem("Pack", PATHNAME.PACK_FOCUS)],
  ),

  getItem(
    "Check Out",
    "sub4",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [
      getItem("Update tracking ", PATHNAME.UPLOADTRACKING),
      getItem("CheckOut Focus", PATHNAME.CHECKOUTORDER_FOCUS),
      getItem("Cancel Checkout", PATHNAME.RETURNORDERFOCUS),
      getItem("Shipping Management", PATHNAME.SHIPPING_MANAGE),
    ],
  ),

  getItem("User Management", "sub5", <UserOutlined />, [
    getItem("พนักงานในระบบ", PATHNAME.USER_ALL),
    getItem("เพิ่ม/แก้ไข พนักงาน", PATHNAME.USER_MANAGED),
  ]),

  getItem("Report Order", PATHNAME.REPORT_ORDER, <FundProjectionScreenOutlined />),
  getItem("Hydro Chat", PATHNAME.HYDRO_CHAT, <WechatFilled />),
];

const MENU_SUPER_ADMIN: MenuProps["items"] = [
  getItem("Order Summary", PATHNAME.DASHBOARD, <BarChartOutlined />),
  getItem("Order Warehouse", PATHNAME.DASHBOARDECOM, <BarChartOutlined />),
  getItem("Reserve Stock", PATHNAME.RESERVE_STOCK, <DatabaseOutlined />),
  getItem("Management", "sub1", <FileSearchOutlined />, [
    getItem("Gen Batch", PATHNAME.PRINT_BATCH),
    getItem("Calendar Order ", PATHNAME.MANAGE_ORDER),
    getItem("Daily Order", PATHNAME.SUM_ORDER),
    getItem("Daily Order Express", PATHNAME.SUM_ORDER_EXPRESS),
    getItem("Products", PATHNAME.SEACH_ITEM),
    // getItem("Batch Schedule", PATHNAME.BATCH_SCHEDULE),
  ]),

  getItem("Manage Status Order", "sub9", <FormOutlined />, [
    getItem("Waiting Order", PATHNAME.EDITWAITING),
    getItem("Holder Order ", PATHNAME.EDITHOLDER),
  ]),

  getItem("So Management", PATHNAME.ORDER_SO, <ExceptionOutlined />),
  getItem("Edit SKU(Holder)", "sub7", <FileSyncOutlined />, [
    getItem("Add SKU", PATHNAME.EDITSKUADD),
    getItem("Edit Order", PATHNAME.EDITONEORDERTABLE),
    getItem("Edit Multi Order", PATHNAME.EDITONEORDERMULTI),
  ]),

  getItem("Order History", PATHNAME.ORDER_HISTORY, <SnippetsOutlined />),
  getItem("Re-check Order", PATHNAME.RECHECK_ORDER, <CheckCircleOutlined />),
  getItem(
    "Focus",
    "sub3",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [getItem("Pick", PATHNAME.PICK_FOCUS), getItem("Pack", PATHNAME.PACK_FOCUS)],
  ),

  getItem("Cutting Page", PATHNAME.CUTTING_PAGE, <ScissorOutlined />),
  getItem("Code G", PATHNAME.CODE_G_PAGE, <BarcodeOutlined />),
  getItem(
    "Check Out",
    "sub4",
    <ImageIcon src={process.env.PUBLIC_URL + "/icon_focus.png"} alt="Icon" />,
    [
      getItem("Update tracking ", PATHNAME.UPLOADTRACKING),
      getItem("CheckOut Focus", PATHNAME.CHECKOUTORDER_FOCUS),
      getItem("Cancel Checkout", PATHNAME.RETURNORDERFOCUS),
      getItem("Shipping Management", PATHNAME.SHIPPING_MANAGE),
    ],
  ),

  getItem("Supervisor Dashboard", PATHNAME.SUPERVISORDASHBOARD, <BarChartOutlined />),

  getItem("User Management", "sub5", <UserOutlined />, [
    getItem("พนักงานในระบบ", PATHNAME.USER_ALL),
    getItem("เพิ่ม/แก้ไข พนักงาน", PATHNAME.USER_MANAGED),
  ]),

  getItem("Report Order", PATHNAME.REPORT_ORDER, <FundProjectionScreenOutlined />),
  getItem("Hydro Chat", PATHNAME.HYDRO_CHAT, <WechatFilled />),
];

export const MENU_LOGOUT: MenuProps["items"] = [
  {
    key: "logout",
    label: <span>ออกจากระบบ</span>,
    icon: <LogoutOutlined />,
  },
];

export const MENU_ROLE: any = {
  1: MENU_ADMIN,
  2: MENU_ZONE,
  3: MENU_WORKER,
  4: MENU_VIEWER,
  5: MENU_SUBADMIN,
  6: MENU_ADMIN_RBN,
  7: MENU_SUPER_ADMIN,
};

export const Dashboard_ROLE: any = {
  1: PATHNAME.RESERVE_STOCK,
  2: PATHNAME.RESERVE_STOCK,
  3: PATHNAME.RESERVE_STOCK,
  4: PATHNAME.SEACH_ORDER,
  5: PATHNAME.RESERVE_STOCK,
  6: PATHNAME.RESERVE_STOCK,
  7: PATHNAME.RESERVE_STOCK,
};
